import React, { useState } from 'react';
import { Modal, Form, Input, DatePicker, Switch, Button, message } from 'antd';
import { updateLink } from '../api';
import { colors } from '../theme';
import dayjs from 'dayjs';

export default function EditLinkModal({ open, link, getToken, onClose }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  async function handleSubmit() {
    const values = await form.validateFields();
    setLoading(true);
    try {
      const token = await getToken();
      await updateLink(token, link.slug, {
        target_url: values.target_url,
        description: values.description,
        expires_at: values.expires_at ? values.expires_at.toISOString() : null,
        is_active: values.is_active ? 1 : 0
      });
      message.success('Link updated');
      onClose();
    } catch (err) {
      message.error(err.response?.data?.error || 'Failed to update link');
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal
      title={`Edit link: ${link.slug}`}
      open={open}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>Cancel</Button>,
        <Button key="submit" type="primary" loading={loading} onClick={handleSubmit}
          style={{ background: colors.blue }}>
          Save
        </Button>
      ]}
    >
      <Form
        form={form}
        layout="vertical"
        style={{ marginTop: 16 }}
        initialValues={{
          target_url: link.target_url,
          description: link.description,
          expires_at: link.expires_at ? dayjs(link.expires_at) : null,
          is_active: !!link.is_active
        }}
      >
        <Form.Item name="target_url" label="Target URL" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name="description" label="Description">
          <Input />
        </Form.Item>
        <Form.Item name="expires_at" label="Expiry date">
          <DatePicker style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item name="is_active" label="Active" valuePropName="checked">
          <Switch />
        </Form.Item>
      </Form>
    </Modal>
  );
}
